module.exports = __webpack_public_path__ + "img/97.5.d9bc0db7.png";